import {
  fallbackText,
  getDataFromLink,
  isEmptyText,
  Prismic,
  PrismicLink,
  PrismicText,
} from '@landsbankinn/prismic';
import { CardButton, Segment } from '@landsbankinn/ui';
import React from 'react';
import { TextWithLinks } from '../components/slices/TextWithLinks';

interface IProps {
  copy: Prismic.RichText;
  title: Prismic.RichText;
  fields: IField[];
  template: string;
}

interface IField {
  link_text: Prismic.RichText;
  link: Prismic.Link;
}

const renderLink = ({ link_text, link }: IField, i: number) => {
  const linkdata = getDataFromLink(link);
  const title = fallbackText(link_text, linkdata.title ?? undefined);
  return (
    <li key={`link-${i}-${title}`}>
      <PrismicLink value={link} title={title ?? undefined}>
        <CardButton title={title} />
      </PrismicLink>
    </li>
  );
};

export const TextWithLinksContainer = ({
  copy,
  title,
  fields,
  template,
}: IProps) => {
  if (isEmptyText(copy)) {
    return null;
  }
  const isArticle = template === 'article';

  const links = fields?.filter(({ link }) => !!link);

  return (
    <Segment isArticle={isArticle}>
      <TextWithLinks
        copy={<PrismicText value={copy} isArticle={isArticle} />}
        boxTitle={Prismic.text(title)}
        isArticle={isArticle}
      >
        {links?.length && <ul>{links.map(renderLink)}</ul>}
      </TextWithLinks>
    </Segment>
  );
};
